




























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { LocalStorageKeys, CoursesSelected, CourseListItem, Cache } from '@/common/cache';
import { User, Courses } from '@lantern/lantern-sdk';
import { Subscription } from 'vue-rx-decorators';
import { alert } from '@/common/modal';

@Component
export default class EnrollComponent extends Vue {
    @Prop()
    show?: boolean;

    @Subscription(() => Cache.instance.accounts)
    accounts!: User.CanvasAccounts | { mainAccounts: []; subAcccounts: [] };

    @Subscription(() => Cache.instance.coursesSelected)
    coursesSelected!: CoursesSelected | {};

    modal = {
        enroll: {
            show: false,
            cancel: this.enrollCancel,
            submit: this.enrollSubmit,
        }
    };

    async created() {
        this.$cache.coursesArray.next([]);
        await this.loadCourses();
    }

    // coursesSelected: CoursesSelected = {}; // courseID : SectionID

    countCourses: number = 0;
    coursesPageNumber = 1;
    coursesPageSize = 50;

    @Subscription(() => Cache.instance.coursesArray)
    coursesArray!: CourseListItem[] | [];

    paginatedCoursesArray!: CourseListItem[] | [];

    // Load
    async loadCourses() {

        if (this.accounts.mainAccounts.length === 0) {
            const response = await this.$lantern.endpoints.User.getAccounts();

            const accounts = response.data;
            this.$cache.accounts.next(accounts);
        }

        // Get All courses only fot top level Canvas Accounts Id that User has access to
        const token = window.localStorage.getItem(LocalStorageKeys.AuthToken);
        if (token) {
            try {
                this.countCourses = 0;
                this.coursesArray = [];

                // 50 - max record per request even though the docs says different
                this.accounts.mainAccounts.forEach(async (element: string) => {
                    const [accountId, name, parentId] = element.split(':');
                    let moreCourses = true;
                    let pageNumber = 1;
                    
                    while (moreCourses) {
                        const response = await this.$lantern.endpoints.Courses.getAllCourses({ accountId, pageSize: this.coursesPageSize, pageNumber });

                        if (response.data.items.length === 0) {
                            moreCourses = false;
                            this.paginatedCoursesArray = this.coursesArray.slice(0, this.coursesPageSize);
                        } else {
                            pageNumber++;
                            this.countCourses += response.data.items.length;
                            response.data.items.forEach(async (course: Courses.Course) => {
                                let selected = false;
                                if (this.coursesSelected.hasOwnProperty(course.id)) selected = true;

                                const el = { ...course, selected, sections: [], pickedSection: null };
                                (this.coursesArray as CourseListItem[]).push(el);
                            });  
                        }
                    }
                });

                // TODO check if course sellected - show picked courses

                this.$cache.coursesArray.next(this.coursesArray);

            } catch (error: any) {
                await alert(error.message);
            }
        }
    }

    // #region COURSES HENDLERS
    async handleCourseClick(course: CourseListItem, selected: boolean) {

        // show sections to a user
        await this.getSection(course, selected);

        // add or deletre course from selection
        this.addSingleCourse(course, selected);
    }

    addSingleCourse(course: CourseListItem, selected: boolean) {

        if (selected) {
            (this.coursesSelected as CoursesSelected)[`${course.id}`] = course;
        } else {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete (this.coursesSelected as CoursesSelected)[`${course.id}`];
        }
        this.$cache.coursesSelected.next(this.coursesSelected);
    }

    paginateCourses() {
        this.paginatedCoursesArray = this.coursesPageNumber === 1 ? this.coursesArray.slice(0, this.coursesPageSize)
            : this.coursesArray.slice((this.coursesPageNumber - 1) * this.coursesPageSize, this.coursesPageNumber * this.coursesPageSize);
    }

    private async getAllSectionsForCourse(courseId: number): Promise<Courses.Section[]> {
        const pageSize = 50;
        const sections: Courses.Section[] = [];
        const response = await this.$lantern.endpoints.Courses.getSections(courseId, { pageSize, pageNumber: 1 });
        const lastPage = response.data.pages;
        sections.push(...response.data.items);

        const responseProm: ReturnType<typeof Courses.getSections>[] = [];
        for (let pageNumber = 2; pageNumber <= lastPage; pageNumber++) {
            responseProm.push(this.$lantern.endpoints.Courses.getSections(courseId, { pageSize, pageNumber }));
        }
        await Promise.all(
            await responseProm.map(async req => {
                const resolveCourse = await req;
                return sections.push(...resolveCourse.data.items);
            })
        );
        return sections;
    }

    async getSection(course: CourseListItem, selected: boolean) {
        if (!selected) return;
        const token = window.localStorage.getItem(LocalStorageKeys.AuthToken);

        if (token) {
            try {
                const sections = await this.getAllSectionsForCourse(course.id);

                // eslint-disable-next-line require-atomic-updates
                course.sections = sections.sort((a, b) => {
                    if (!a.start_at) return 1;
                    if (!b.start_at) return -1;
                    if (new Date(b.start_at).getTime() > new Date(a.start_at).getTime()) return 1;
                    return -1;
                });
            } catch (error: any) {
                await alert(error.message);
            }
        }
    }

    async enrollSubmit() {

        let allSectionsCreated = true;
        let CourseFailed = '';
        for (const course in this.coursesSelected) {
            if (this.coursesSelected.hasOwnProperty(course)) {

                // if section doesn't exist we need to create it
                if (!(<CoursesSelected> this.coursesSelected)[course].pickedSection && (<CoursesSelected> this.coursesSelected)[course].sections.length === 0) {
                    allSectionsCreated = false;
                    CourseFailed = (<CoursesSelected> this.coursesSelected)[course].name;
                }
            }
        }

        if (allSectionsCreated && Object.keys(this.coursesSelected).length !== 0) {
            this.$emit('submit');
            this.$cache.coursesArray.next([]);
        } else if (Object.keys(this.coursesSelected).length === 0) {
            await alert('Please pick a course');
        } else {
            await alert(`Please create a section for course: ${CourseFailed}`);
        }
    }

    async enrollCancel() {

        this.coursesSelected = {};
        this.coursesPageNumber = 1;
        this.$cache.coursesSelected.next({});
        this.$cache.coursesArray.next([]);

        this.$emit('close');
    }

    @Watch('coursesPageNumber')
    onCoursesPageNumberChanged() {
        this.paginateCourses();
    }

    @Watch('show')
    onShowChanged() {
        this.loadCourses();
    }
    // #endregion COURSES HENDLERS

    createSection(course: CourseListItem) {
        this.$emit('createSection', course);
    }

    changeSection(course: CourseListItem) {
        this.$emit('changeSection', course);
    }
}

